var Plotly = require('plotly.js/dist/plotly.min.js');

// ─── CSV 생성 ────────────────────────────────────────────────────────────────

function escapeField(v) {
  var s = String(v == null ? '' : v);
  if (s.indexOf(',') !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
}

function buildCsv(gd) {
  var traces = gd.data;
  if (!traces || traces.length === 0) return null;

  var lines = [];
  var firstType = traces[0].type;

  // Pie 차트
  if (firstType === 'pie') {
    var pieTraces = traces.filter(function(t) { return t.labels && t.values; });
    if (!pieTraces.length) return null;

    lines.push(['label'].concat(pieTraces.map(function(t) { return t.name || 'value'; })).map(escapeField).join(','));
    for (var p = 0; p < pieTraces[0].labels.length; p++) {
      lines.push([pieTraces[0].labels[p]].concat(pieTraces.map(function(t) {
        return t.values[p] != null ? t.values[p] : '';
      })).map(escapeField).join(','));
    }
    return lines.join('\n');
  }

  // 3D 산점도
  if (firstType === 'scatter3d') {
    var t3d = traces.filter(function(t) { return t.x && t.y && t.z; });
    if (!t3d.length) return null;

    var hdr3 = t3d.length > 1
      ? t3d.reduce(function(acc, t) {
          var n = t.name || 'trace';
          return acc.concat([n + '_x', n + '_y', n + '_z']);
        }, [])
      : ['x', 'y', 'z'];
    lines.push(hdr3.map(escapeField).join(','));

    var len3 = Math.max.apply(null, t3d.map(function(t) { return t.x.length; }));
    for (var i3 = 0; i3 < len3; i3++) {
      lines.push(t3d.reduce(function(acc, t) {
        return acc.concat([
          t.x[i3] != null ? t.x[i3] : '',
          t.y[i3] != null ? t.y[i3] : '',
          t.z[i3] != null ? t.z[i3] : ''
        ]);
      }, []).map(escapeField).join(','));
    }
    return lines.join('\n');
  }

  // 일반 x/y 트레이스 (scatter, bar 등)
  var valid = traces.filter(function(t) { return t.x && t.y && t.x.length > 0; });
  if (!valid.length) return null;

  lines.push(['x'].concat(valid.map(function(t) { return t.name || 'value'; })).map(escapeField).join(','));

  var firstX = valid[0].x;
  var allSameX = valid.every(function(t) {
    return t.x.length === firstX.length &&
      String(t.x[0]) === String(firstX[0]) &&
      String(t.x[t.x.length - 1]) === String(firstX[firstX.length - 1]);
  });

  if (allSameX) {
    for (var i = 0; i < firstX.length; i++) {
      lines.push([firstX[i]].concat(valid.map(function(t) {
        return t.y[i] != null ? t.y[i] : '';
      })).map(escapeField).join(','));
    }
  } else {
    // x 값이 서로 다를 때: x 기준 정렬 병합
    var xMap = new Map();
    valid.forEach(function(t, ti) {
      t.x.forEach(function(xVal, i) {
        var key = String(xVal);
        if (!xMap.has(key)) xMap.set(key, { x: xVal, vals: new Array(valid.length).fill('') });
        xMap.get(key).vals[ti] = t.y[i] != null ? t.y[i] : '';
      });
    });
    Array.from(xMap.keys()).sort().forEach(function(key) {
      var entry = xMap.get(key);
      lines.push([entry.x].concat(entry.vals).map(escapeField).join(','));
    });
  }

  return lines.join('\n');
}

// ─── 다운로드 트리거 ──────────────────────────────────────────────────────────

function triggerDownload(gd) {
  var csv = buildCsv(gd);
  if (!csv) return;

  var title = '';
  if (gd.layout && gd.layout.title) {
    title = typeof gd.layout.title === 'string'
      ? gd.layout.title
      : (gd.layout.title.text || '');
  }
  if (!title) title = gd.id || 'chart_data';

  // 파일명에 사용 불가한 문자 제거
  var filename = title.replace(/[<>:"/\\|?*\x00-\x1f]/g, '_').replace(/_{2,}/g, '_') + '.csv';

  var blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// ─── Modebar 버튼 정의 ────────────────────────────────────────────────────────

var csvButton = {
  name: 'Download CSV',
  title: 'CSV 다운로드',
  // Bootstrap Icons "download" (16×16)
  icon: {
    width: 16,
    height: 16,
    path: 'M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5zm7.646 1.354a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z'
  },
  click: triggerDownload
};

// ─── Plotly 전역 패치 ─────────────────────────────────────────────────────────

function injectCsvButton(config) {
  // displayModeBar: false 인 차트는 건너뜀
  if (config && config.displayModeBar === false) return config;
  var cfg = Object.assign({}, config);
  cfg.modeBarButtonsToAdd = [csvButton].concat(cfg.modeBarButtonsToAdd || []);
  return cfg;
}

var _origNewPlot = Plotly.newPlot;
Plotly.newPlot = function(id, data, layout, config) {
  return _origNewPlot.call(Plotly, id, data, layout, injectCsvButton(config));
};

if (typeof Plotly.react === 'function') {
  var _origReact = Plotly.react;
  Plotly.react = function(id, data, layout, config) {
    return _origReact.call(Plotly, id, data, layout, injectCsvButton(config));
  };
}

if (typeof Plotly.plot === 'function') {
  var _origPlot = Plotly.plot;
  Plotly.plot = function(id, data, layout, config) {
    return _origPlot.call(Plotly, id, data, layout, injectCsvButton(config));
  };
}



// WEBPACK FOOTER //
// ./src/plugins/plotlyPlugin.js